import About from "@/components/About";
import Contact from "@/components/Contact";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

function ContattiPage() {
  return (
    <div className="pt-28 sm:pt-32">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 mb-6">
        <Link
          to="/"
          data-testid="contact-back"
          className="inline-flex items-center gap-2 font-mono text-[0.7rem] tracking-[0.35em] uppercase text-muted hover:text-ink transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Home
        </Link>
      </div>
      <About />
      <Contact />
    </div>
  );
}

export default ContattiPage;
